import { mountJwtDecoder } from './ui';

function boot(): void {
	const nodes = document.querySelectorAll<HTMLElement>('[data-kb-tool="jwt-decoder"]');
	nodes.forEach((node) => {
		if (node.dataset.kbMounted === '1') {
			return;
		}
		node.dataset.kbMounted = '1';
		mountJwtDecoder(node);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}
